import fetch from 'node-fetch';

/*
 * Ambil satu baris StaticPage untuk halaman legal publik.
 *
 * Route action ini berjalan di SERVER dan di KLIEN (router universal), jadi
 * modelnya tidak boleh diimpor langsung — sequelize tidak boleh ikut ke bundel
 * browser. Tetap lewat /graphql, seperti routes/static/*.
 *
 * Bedanya: route lama memakai `siteUrl` dari config untuk memanggil dirinya
 * sendiri, dan SITE_URL di .env lokal menunjuk host lain yang sudah mati —
 * itulah sebabnya /legal memberi 500 di lokal. Di sini URL-nya diri sendiri:
 * relatif di browser, loopback + PORT di server. Tidak bisa rusak karena env.
 *
 * Gagal fetch mengembalikan null, bukan melempar: halaman legal kosong masih
 * lebih baik daripada 500 di route yang ditautkan setiap footer.
 */
const QUERY = `query getEditStaticPage ($id: Int!) {
  getEditStaticPage (id: $id) {
    result {
      id
      pageName
      content
      metaTitle
      metaDescription
      dynamicStaticContentSettings {
        id
        contentId
        language
        content
      }
    }
  }
}`;

const selfUrl = () => (typeof window === 'undefined'
  ? `http://127.0.0.1:${process.env.PORT || 3000}/graphql`
  : '/graphql');

export default async function fetchStaticPage(id) {
  try {
    const resp = await fetch(selfUrl(), {
      method: 'post',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ query: QUERY, variables: { id } }),
      credentials: 'include',
    });
    const { data } = await resp.json();
    return (data && data.getEditStaticPage && data.getEditStaticPage.result) || null;
  } catch (e) {
    return null;
  }
}
